const E = 60, S = 3600, _ = 86400, N = 2678400, O = 31536e3;
export {
  _ as SECONDS_PER_DAY,
  S as SECONDS_PER_HOUR,
  E as SECONDS_PER_MINUTE,
  N as SECONDS_PER_MONTH,
  O as SECONDS_PER_YEAR
};
